/**
 * Created by jianghui on 2018/5/19.
 */
let echarts = require('echarts');
const util = {
    validPhone(rule, value, callback) {
        if (!value) {
            callback(new Error('请输入手机号码!'))
        } else if (!util.isvalidPhone(value)) {
            callback(new Error('请输入正确的11位手机号码!'))
        } else {
            callback()
        }
    },
    /**
     * 不能输入汉字验证
     */
    validChinese(rule, value, callback) {
        if (/[\u4E00-\u9FA5]/g.test(value)) {
            callback(new Error('不能输入汉字!'));
        } else {
            callback();
        }
    },
    valid0(value){
        var reg = new RegExp('^0|0[.]?[0]∗0')
        if (reg.test(value)){
            return false;
        } else {
            return true;
        }
    },
    /**
     * 只能输入数字及小数点
     */
    validNumber(rule, value, callback){
         if (! /^\d+$|^\d*\.\d+$/g.test(value)) {
            callback(new Error('必须为整数或者小数'));
        } else {
            callback();
        }
    },
    isvalidPhone(str) {
        const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
        return reg.test(str.trim())
    },
    hasClass(elements, cName) {
        if (elements) {
            return !!elements.className.match(new RegExp("(\\s|^)" + cName + "(\\s|$)"));
        }
    },
    addClass(elements, cName) {
        if (!util.hasClass(elements, cName)) {
            elements.className += " " + cName;
        }
        ;
    },
    removeClass(elements, cName) {
        if (util.hasClass(elements, cName)) {
            elements.className = elements.className.replace(new RegExp("(\\s|^)" + cName + "(\\s|$)"), " ");
        }
        ;
    },
    // 判断字符串是否为空
    isNullOrEmpty(x) {
        return (x == null || typeof x == "undefined" || x.length == 0) ? true : false;
    },
    // 格式化时间,date1可以不传参数，则取出当前时间
    formatDate(formatStr, date1) {
        var date = new Date();
        if (typeof date1 === 'string') {
            if (util.isNullOrEmpty(date1) || date1.substring(0, 10) == "1900-01-01")
                return "";
            date = new Date(date1);
        } else {
            if (date1 != null) {
                date = date1;
            } else {
                return "";
            }
        }

        /*
         函数：填充0字符
         参数：value-需要填充的字符串, length-总长度
         返回：填充后的字符串
         */

        var zeroize = function (value, length) {
            if (!length) {
                length = 2;
            }
            value = new String(value);
            for (var i = 0, zeros = ''; i < (length - value.length); i++) {
                zeros += '0';
            }
            return zeros + value;
        };

        return formatStr.replace(/"[^"]*"|'[^']*'|\b(?:d{1,4}|M{1,4}|yy(?:yy)?|([hHmstT])\1?|[lLZ])\b/g, function ($0) {
            switch ($0) {
                case 'd':
                    return date.getDate();
                case 'dd':
                    return zeroize(date.getDate());
                case 'ddd':
                    return ['Sun', 'Mon', 'Tue', 'Wed', 'Thr', 'Fri', 'Sat'][date.getDay()];
                case 'dddd':
                    return ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][date.getDay()];
                case 'M':
                    return date.getMonth() + 1;
                case 'MM':
                    return zeroize(date.getMonth() + 1);
                case 'MMM':
                    return ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][date.getMonth()];
                case 'MMMM':
                    return ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'][date.getMonth()];
                case 'yy':
                    return new String(date.getFullYear()).substr(2);
                case 'yyyy':
                    return date.getFullYear();
                case 'h':
                    return date.getHours() % 12 || 12;
                case 'hh':
                    return zeroize(date.getHours() % 12 || 12);
                case 'H':
                    return date.getHours();
                case 'HH':
                    return zeroize(date.getHours());
                case 'm':
                    return date.getMinutes();
                case 'mm':
                    return zeroize(date.getMinutes());
                case 's':
                    return date.getSeconds();
                case 'ss':
                    return zeroize(date.getSeconds());
                case 'l':
                    return date.getMilliseconds();
                case 'll':
                    return zeroize(date.getMilliseconds());
                case 'tt':
                    return date.getHours() < 12 ? 'am' : 'pm';
                case 'TT':
                    return date.getHours() < 12 ? 'AM' : 'PM';
            }
        });
    },

    buildOption: function (_id, _option, _json) {
        let chart = echarts.init(document.getElementById(_id));
        // chart.clear();
        chart.setOption(_option);

        this.addEventResize(chart.resize);
    },
    //页面缩放后,echarts大小重置
    addEventResize: function (func) {
        let originFn = window.onresize;
        window.onresize = function () {
            originFn && originFn();
            func();
        }
    }
};

export default util



// WEBPACK FOOTER //
// ./src/assets/js/util.js